import type { FC } from "react";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getShortcutLabel } from "src/utils/platform";

interface CommandPaletteTriggerProps {
  onOpen: () => void;
}

const CommandPaletteTrigger: FC<CommandPaletteTriggerProps> = ({ onOpen }) => {
  const { t } = useTranslation("common");

  return (
    <>
      {/* Full search bar - visible at lg and above */}
      <button
        type="button"
        onClick={onOpen}
        className="hidden lg:flex items-center gap-2 border border-gray-200 rounded-lg bg-gray-50 hover:bg-gray-100 px-3 h-9 w-full max-w-md cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
      >
        <Search className="h-4 w-4 text-gray-400 flex-shrink-0" />
        <span className="text-sm text-gray-400 flex-1 text-left truncate">
          {t("navbar.search-placeholder")}
        </span>
        <kbd className="hidden sm:inline-flex items-center gap-0.5 rounded border border-gray-200 bg-white px-1.5 py-0.5 text-[10px] font-medium text-gray-400">
          {getShortcutLabel("K")}
        </kbd>
      </button>

      {/* Icon-only trigger - visible below lg */}
      <button
        type="button"
        onClick={onOpen}
        className="lg:hidden flex items-center justify-center p-2 rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
        aria-label={t("navbar.search-placeholder")}
      >
        <Search className="h-5 w-5" />
      </button>
    </>
  );
};

export default CommandPaletteTrigger;
